export enum CheckoutStep {
  POLICY = "POLICY",
  KYC = "KYC",
  CREDIT_CHECK = "CREDIT_CHECK",
  CUSTOMER_CONTACT_INFO = "CUSTOMER_CONTACT_INFO",
  OFFERS = "OFFERS",
  CONTRACT = "CONTRACT",
  SOFTWARE_INSTALLATION = "SOFTWARE_INSTALLATION",
  RECEIPT = "RECEIPT",
}

export enum CheckoutStepToNavbar {
  POLICY = 1,
  KYC = 1,
  CREDIT_CHECK = 1,
  CUSTOMER_CONTACT_INFO = 1,
  OFFERS = "OFFERS",
  CONTRACT = "CONTRACT",
  SOFTWARE_INSTALLATION = "SOFTWARE_INSTALLATION",
  RECEIPT = "RECEIPT",
}
